const RE_ROUTE_VARIABLE = require('./RE_ROUTE_VARIABLE');
const QueryString = require('../rlink-querystring');

module.exports = function fillRoutePattern (routePattern, params) {
  let unfilledParams = Object.assign({}, params);
  return routePattern.replace(RE_ROUTE_VARIABLE, (match, paramName) => {
    delete unfilledParams[paramName];
    return params[paramName];
  }) + QueryString.makeQuery(unfilledParams, '#?');
};



// WEBPACK FOOTER //
// ./lib/rlink-router/fillRoutePattern.js